import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { packItems, volumes, volumesIntro } from '../data/teatro';
export function WhatsInside() {
  const [active, setActive] = useState<number>(0);
  const volume = volumes[active];
  return <section id="inside" className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-295" data-mp="pujdnqvwgpbh">
      <div className="mx-auto max-w-6xl" data-id="element-296" data-mp="b5wmmrwwu94f">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-297" data-mp="b4vccpnpxqnr">
          Cosa trovi dentro <em className="text-red-700" data-id="element-298" data-mp="269uyxtzghok">TEATRO PRONTO™</em>?
        </h2>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-299" data-mp="23x57yhzh30y">
          <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-300" data-mp="75cslx7mvlmi">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-301" data-mp="3tckq6dcbao7z">{volumesIntro.text}</p>
        </div>

        <div role="tablist" aria-label="Volumi" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-302" data-mp="3ct4k2ebcultb">
          {volumes.map((item, index) => {
          const isActive = index === active;
          return <button key={item.number} type="button" role="tab" id={`volume-tab-${index}`} aria-selected={isActive} aria-controls="volume-panel" onClick={() => setActive(index)} className={`flex h-56 flex-col rounded-lg border-r-8 border-black/10 p-4 text-left shadow-xl shadow-slate-900/20 transition-[transform,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/40 sm:h-64 lg:h-72 ${item.spine} ${isActive ? '-translate-y-2' : 'opacity-75 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-303" data-mp="3ltayc2evnptj" data-mpi={index}>
                <span className="text-xs font-semibold opacity-80" data-id="element-304" data-mp="2y36t5qm1ji0f">{item.number}</span>
                <span className="mt-1 font-serif text-2xl leading-none sm:text-3xl" data-id="element-305" data-mp="2adm5wviutylc">{item.level}</span>
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${item.rule}`} data-id="element-306" data-mp="26bra26jp0dey">
                  {item.title}
                </span>
              </button>;
        })}
        </div>

        <div id="volume-panel" role="tabpanel" aria-labelledby={`volume-tab-${active}`} className="mt-8 border-t border-slate-900/15 pt-10" data-id="element-307" data-mp="ea7q1wqclj7q">
          <AnimatePresence mode="wait" initial={false} data-id="element-308" data-mp="o2dhn5cotyme">
            <motion.div key={volume.number} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 lg:grid-cols-12" data-id="element-309" data-mp="o46tcz25r919">
              <div className="lg:col-span-5" data-id="element-310" data-mp="5d77i6pymfc7">
                <p className="text-sm font-semibold text-red-700" data-id="element-311" data-mp="1brojkq5rxz24">
                  {volume.number} · {volume.classes}
                </p>
                <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-312" data-mp="1gpq1h7rgrsc0">{volume.title}</h4>
                <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-313" data-mp="318agv5olklru">{volume.tagline}</p>
                <p className="mt-3 leading-relaxed text-slate-900/70" data-id="element-314" data-mp="2wa8vuf7m2cdq">{volume.intro}</p>
              </div>
              <div className="lg:col-span-7" data-id="element-315" data-mp="2rh61w5yx90x0">
                <p className="text-sm font-semibold text-slate-900/60" data-id="element-316" data-mp="2mkfknfbdrza0">Contiene</p>
                <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-317" data-mp="2hkumv87y5wyv">
                  {volume.items.map(entry => <li key={entry} className="flex gap-3 text-[15px] leading-snug text-slate-900/80" data-id="element-318" data-mp="2dj94x8gk2sht">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-319" data-mp="28jwe6cmkd19y" />
                      {entry}
                    </li>)}
                </ul>
                <p className="mt-6 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-320" data-mp="6sjcdwfw79i4">{volume.outro}</p>
                {volume.note && <p className="mt-3 text-xs leading-relaxed text-slate-900/60" data-id="element-321" data-mp="1tf1909er1p5">{volume.note}</p>}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-24 border-t border-slate-900/15 pt-12" data-id="element-322" data-mp="2zn04h63oq0hz">
          <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-323" data-mp="2zl5nu3zg4ujp">
            <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-324" data-mp="2lmpc1ymq8dup">
              Cosa rende diverso TEATRO PRONTO™?
            </h3>
            <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-325" data-mp="2bx5ssrv3qhzb">
              Un anno intero di teatro a scuola – organizzato e pronto da usare.
            </p>
          </div>
          <ul className="mt-12 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-326" data-mp="22xiwgkh8c2d4">
            {packItems.map(item => {
            const Icon = item.icon;
            return <li key={item.title} data-id="element-327" data-mp="27tpt1mnqk1ie">
                  <Icon className="h-6 w-6 text-red-700" strokeWidth={1.75} aria-hidden="true" data-id="element-328" data-mp="1syjoz587acrp" />
                  <h4 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-329" data-mp="1xy5zv80k3gxc">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-slate-900/70" data-id="element-330" data-mp="1ebcnrr8iot60">{item.text}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}